
export default {
  getName: (state) => state.name,
  getNextSeqCode: (state) => state.nextSeqCode,

  getEquipmentStatuses: (state) => state.equipmentStatuses,
}